<template>
    <div v-frag>
        <CardIeaAppMain>
            <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <v-card class="mt-5">
                    <v-card-title class="d-flex justify-left pl-4">
                        <p style="word-break: keep-all !important;">Se envió un correo con tus
                            credenciales</p>
                    </v-card-title>
                    <v-card-text class="">
                        <v-container fluid>
                            <v-col cols="8" sm="12" md="12" lg="8">
                                Usuario:
                                <v-text-field v-model="user" disabled></v-text-field>
                            </v-col>
                            <v-row>
                                <v-col class="ms-2" cols="12" sm="12" md="4" lg="4" xl="4">
                                    Password:
                                    <v-text-field v-model="password" disabled></v-text-field>
                                </v-col>
                                <v-col class="mt-4" cols="12" sm="12" md="6" lg="6" xl="6">
                                    <v-alert dense type="warning">
                                        Esta contraseña es temporal, recomendamos cambiarla por seguridad
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <div class="row">
                                <v-col cols="12" sm="12" md="4" lg="4">
                                    <code class="text-h6">https://public.sistemaiea.com/login</code>
                                    <!-- <v-text-field  readonly :value="'https://public.sistemaiea.com/login'"></v-text-field> -->
                                  
                                </v-col>
                                <v-col cols="12" sm="12" md="6" lg="6">
                                    <v-btn class="ml-3" fab x-small @click="copiarUrl"><v-icon
                                        small>mdi-content-copy</v-icon></v-btn>
                                    <v-btn @click="irLogin()" class="ms-2 white--text rounded-lg " depressed
                                        color="btnSuccess"> Ir a Login</v-btn>
                                </v-col>

                            </div>


                        </v-container>
                    </v-card-text>
                    <!-- <v-card-actions>
                        <v-spacer></v-spacer> 
                         <v-btn block class="white--text rounded-lg font-weight-regular" color="#4caf50" text
                            @click="irLogin()">
                            Ir a Login
                        </v-btn>
                        <v-btn @click="irLogin()" class="white--text rounded-lg " depressed color="btnSuccess"> Ir a
                            Login</v-btn>
                    </v-card-actions> -->
                </v-card>
            </v-col>
        </CardIeaAppMain>
    </div>

</template>
<script>

import CardIeaAppMain from "../../components/CardIeaAppMain";
export default {
    components: {
        CardIeaAppMain
    },
    data() {
        return {
            user: '',
            password: ''
        }
    },
    methods: {
        irLogin() {
            this.$router.push({ name: 'Login' });
        },
        copiarUrl() {
            navigator.clipboard.writeText("https://public.sistemaiea.com/login")
        },
        async validarHash() {
            if (this.$route.query.makehash && this.$route.query.makehashprefix && this.$route.query.prefix) {
                let url = "circuito/validate";
                await this.$API
                    .post({
                        url: url,
                        data: {
                            hash: this.$route.query.makehash,
                            prefix: this.$route.query.prefix,
                            makehashprefix:this.$route.query.makehashprefix
                        }
                    }).then((res) => {
                        if (res.estado) {
                            this.user = res.alumno.Usuario
                            this.password = res.alumno.datoPass
                        } else {
                            this.$router.push({ name: 'Login' })

                        }
                    });
            } else {
                this.$router.push({ name: 'Login' })
            }
        }
    },
    mounted() {
        this.validarHash()
    }
}
</script>